import React from 'react'
import { CircularProgress, Typography, Box } from '@mui/material'
import { useGetFormStatsQuery } from '@/core/services/form'
import { FormTemplate } from '@/core/models/form.model'
import FormStatistics from '../components/FormStatistics'

interface FormStatisticsContainerProps {
    template: FormTemplate
}

const FormStatisticsContainer: React.FC<FormStatisticsContainerProps> = ({ template }) => {
    const { data: statistics, isLoading, error } = useGetFormStatsQuery(template._id)

    console.log('form stats container', statistics)

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        )
    }

    if (error) {
        return (
            <Typography color="error" sx={{ p: 3 }}>
                Error loading statistics
            </Typography>
        )
    }

    if (!statistics) {
        return (
            <Typography color="text.secondary" sx={{ p: 3 }}>
                No statistics available
            </Typography>
        )
    }

    return <FormStatistics template={template} statistics={statistics} />
}

export default FormStatisticsContainer 